'use strict';

angular.module('webAgro1App').factory('InformacoesCultivaresService', function($http) {
  return {
    getDataPlantio: function(params) {
      var url = SERVER + API_VERSION + 'datas_plantio';

      return $http.get(url, {params: params});
    },

    get: function(params) {
      var url = SERVER + API_VERSION + 'informacoes_cultivares';
      params = params || {};
      params.no_paginate = true;

      return $http.get(url, {params: params});
    },
  };
});
